import { AIRCALL_API_ENDPOINTS, AIRCALL_ENABLED } from './aircall.const';
import { SALESFORCE_API_ENDPOINTS, SALESFORCE_ENABLED } from './salesforce.const';

const API_TYPES = {
  GET: 'GET',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
};

const API_ENDPOINTS = {
  INTEGRATION: '/v1/integrations',
  TOGGLE_SOLUTION: '/v1/integrations/toggle_solution',
  SALESFORCE: SALESFORCE_API_ENDPOINTS,
  AIRCALL: AIRCALL_API_ENDPOINTS,
};

const ACTION_TYPES = {
  UPDATE_INTEGRATION_LIST: 'UPDATE_INTEGRATION_LIST',
  UPDATE_SELECTED_APP_DATA: 'UPDATE_SELECTED_APP_DATA',
  DISPATCH_WIDGET_ENABLE: 'DISPATCH_WIDGET_ENABLE',
  UPDATE_INTEGRATION_LIST_FAIL: 'UPDATE_INTEGRATION_LIST_FAIL',
  DISPATCH_WIDGET_ENABLE_FAIL: 'DISPATCH_WIDGET_ENABLE_FAIL',
  SET_USER_PROFILE_DATA: 'SET_USER_PROFILE_DATA',
  SET_AIRCALL_SOLUTION_ID: 'SET_AIRCALL_SOLUTION_ID',
  SET_VOICE_INBOX_DATA: 'SET_VOICE_INBOX_DATA',
  SET_AIRCALL_PHONE_NUMBER_LIST: 'SET_AIRCALL_PHONE_NUMBER_LIST',
  RESET_VOICE_INBOX_DATA: 'RESET_VOICE_INBOX_DATA',
  SET_VOICE_INBOX_AUTH_USER_DATA: 'SET_VOICE_INBOX_AUTH_USER_DATA'
};

const MSG_INTEGRATIN_GET = 'Failed to fetch integration marketplace';

const TRAY_AUTH_EVENT_MSG = {
  ORIGIN: 'https://hiver.integration-configuration.com',
  TYPE: 'tray.configPopup.finish',
  DISMISS: 'tray.configPopup.cancel',
};

const WIDGET_ENABLED = {
  SALESFORCE: SALESFORCE_ENABLED,
  AIRCALL: AIRCALL_ENABLED,
};

export {
  API_TYPES,
  API_ENDPOINTS,
  ACTION_TYPES,
  MSG_INTEGRATIN_GET,
  TRAY_AUTH_EVENT_MSG,
  WIDGET_ENABLED,
};
